import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGroup } from '../../api/groupCustomerV2/groupCustomerV2Api';

const initialGroupCustumerSlice: IGroup[] = []

const groupCustumerSlice = createSlice({
  name: 'groupCustumerSlice',
  initialState: initialGroupCustumerSlice,
  reducers: {
    setGroupCustumer: (state, action: PayloadAction<IGroup[]>) => action.payload,
    clearGroupCustumer: (state) => initialGroupCustumerSlice
  }
})

export const selectorGroupCustumer = (state: { groupCustumerSlice: IGroup[] }) => state.groupCustumerSlice;
export const { setGroupCustumer, clearGroupCustumer } = groupCustumerSlice.actions;
export default groupCustumerSlice.reducer;
